export const ActionTypes = {
  LOADING: "UPDATE_CRITERIA_LOADING",
  ERROR: "UPDATE_CRITERIA_ERROR",
  SUCCESS: "UPDATE_CRITERIA_SUCCESS",
};
